/**
 * The daily step targets a challenge groups members by.
 *
 * The target-group standing used to group on the exact number a member chose,
 * which works only while everybody picks one of the three presets. Anyone who
 * typed their own number got a standing of one: a 15,000-step member was
 * ranked first of one, every day, against nobody.
 *
 * So a target lands in a band rather than in its own cohort. The bands are the
 * three presets, each one holding every target up to its own number, and the
 * top band holding everything above the middle one. A member who walks 15,000
 * is ranked with the 10,000 crowd, which is a real standing.
 */
/** Ordered by `upTo`, ascending. The last band is unbounded. */
export const STEP_TARGET_BANDS = [
    { targetSteps: 5_000, upTo: 5_000, label: "Up to 5,000 steps" },
    { targetSteps: 7_000, upTo: 7_000, label: "5,000 to 7,000 steps" },
    {
        targetSteps: 10_000,
        upTo: Number.POSITIVE_INFINITY,
        label: "7,000 steps or more",
    },
];
const TOP_BAND = STEP_TARGET_BANDS[STEP_TARGET_BANDS.length - 1];
/**
 * The band a daily target belongs to.
 *
 * A target sits in the first band it does not exceed, so the boundaries read
 * the way the presets do: 5,000 is a 5,000 member, 5,001 walks with the 7,000
 * group, and anything past 7,000 walks with the 10,000 group. A missing or
 * nonsensical target is not a band; the caller leaves that member out.
 */
export function stepTargetBand(targetSteps) {
    if (typeof targetSteps !== "number" || !Number.isFinite(targetSteps) || targetSteps <= 0) {
        return null;
    }
    return STEP_TARGET_BANDS.find((band) => targetSteps <= band.upTo) ?? TOP_BAND;
}
/**
 * How to name a band the wire named by its representative target.
 *
 * Falls back to stating the number for a value that is not a band, which is
 * what a client reading a response from before the bands existed will see.
 */
export function stepTargetBandLabel(targetSteps) {
    const band = STEP_TARGET_BANDS.find((candidate) => candidate.targetSteps === targetSteps);
    return band ? band.label : `${targetSteps.toLocaleString("en-US")} steps`;
}
//# sourceMappingURL=step-target-band.js.map